import { type ButtonHTMLAttributes, type ReactNode } from 'react';

type Variant = 'primary' | 'brand' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
}

// Design Variations button system — 읽기 쉬운 크기, 과하지 않은 굵기
// primary/brand: 라이트 그린 필 + 진한 잉크 텍스트 — 기본 CTA
// secondary: 회색 필 / ghost: 투명 + hover 필 / danger: error red
const VARIANT_CLASS: Record<Variant, string> = {
  primary: 'bg-primary text-white hover:bg-primary-strong focus-visible:shadow-focus-ring',
  // brand: 시그니처 딥그린 그라데이션 + 글로우 — 화면당 하나의 주 CTA
  brand:
    'bg-[image:var(--hero-grad)] text-white shadow-[var(--hero-glow)] hover:brightness-[1.06] focus-visible:shadow-focus-ring',
  secondary: 'bg-surface-muted text-ink hover:bg-surface-pressed',
  ghost: 'bg-transparent text-ink hover:bg-surface-muted',
  danger: 'bg-error text-white hover:bg-error-strong focus-visible:shadow-focus-ring',
};

export function Button({
  variant = 'primary',
  className = '',
  children,
  ...rest
}: ButtonProps) {
  // pressable(foundation.css): active scale(0.97) 스프링 + 색상/그림자 전환 — 모든 버튼 공통 촉감
  const base =
    'pressable inline-flex min-h-[44px] items-center justify-center gap-2 rounded-2xl px-5 py-2.5 text-[14px] font-medium tracking-[-0.1px] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60';
  return (
    <button className={`${base} ${VARIANT_CLASS[variant]} ${className}`} {...rest}>
      {children}
    </button>
  );
}
